import React from 'react';
import * as pt from 'prop-types';
import createReactClass from 'create-react-class';

import moment from 'moment';
import DatePicker from 'react-datepicker';
import _ from 'underscore';
import ScheduleElmt from './Schedule';
import Loader from '../../../common/components/notifications/Loader';

var TechnicianSchedule = createReactClass({
    propTypes: {
        data: pt.shape({
            eventsByTech: pt.object.isRequired,
            techs: pt.array.isRequired
        }),
        onTechChange: pt.func.isRequired,
        onSubmit: pt.func.isRequired,
        filters: pt.shape({
            id: pt.oneOfType([pt.number, pt.string]),
            startDateTime: pt.string.isRequired,
            stopDateTime: pt.string.isRequired
        }).isRequired
    },

    getInitialState: function () {
        var filters = this.props.filters;
        return {
            sortAsc: true,
            startDateTime: moment(filters.startDateTime),
            stopDateTime: moment(filters.stopDateTime)
        };
    },

    handleDateChange: function (dateProp, date) {
        var dates = {};
        dates[dateProp] = date;
        this.setState(dates);
    },

    handleTechChange: function (ev) {
        this.props.onTechChange(ev.target.value);
    },

    // when someone clicks 'get schedule' after changing the date range
    handleSubmit: function (ev) {
        var query = _(this.state).pick('startDateTime', 'stopDateTime');
        this.props.onSubmit(query);
    },

    handleSort: function (ev) {
        ev.preventDefault();
        this.setState({
            sortAsc: !this.state.sortAsc
        });
    },

    render: function () {
        var cl = 'schedule' + (this.state.schedulesResolving ? ' resolving' : '');
        var sortClass = 'fa ' + (this.state.sortAsc ?
            'fa-sort-numeric-asc' :
            'fa-sort-numeric-desc'
        );

        if (this.props.isResolving) {
            return <Loader message='Loading' />;
        }

        var events = this.props.data.eventsByTech[this.props.filters.id];
        events = events || [];

        return (<div>
            <div className="schedule-page">

                <div className="panel panel-default hidden-print">
                    <div className="panel-heading">
                        <div className="panel-title">
                            <div className="panel-title">
                                Filter
                            </div>
                        </div>
                    </div>

                    <div className="panel-body">
                        <div className="col-xs-4">
                            Start Date
                            <DatePicker className="form-control"
                                selected={this.state.startDateTime}
                                onChange={this.handleDateChange.bind(this, 'startDateTime')}
                            >
                            </DatePicker>
                        </div>

                        <div className="col-xs-4">
                            End Date
                            <DatePicker className="form-control"
                                selected={this.state.stopDateTime}
                                onChange={this.handleDateChange.bind(this, 'stopDateTime')}
                            >
                            </DatePicker>
                        </div>

                        <div className="col-xs-4">
                            Technician
                            <select className="form-control"
                                value={this.props.filters.id}
                                onChange={this.handleTechChange}>
                                {_(this.props.data.techs).sortBy('techName')
                                    .map(function (tech) {
                                        return (
                                            <option value={tech.techID}
                                                key={tech.techID}>
                                                {tech.techName}
                                            </option>
                                        );
                                    })
                                }
                            </select>
                        </div>

                    </div>

                    <div className="panel-footer">
                        <div className="row">
                            <button
                                className="btn btn-primary pull-right"
                                onClick={this.handleSubmit}
                            >
                                Get Schedule
                            </button>
                        </div>
                    </div>

                </div>


                <div className="text-right sort-control">
                    <a href="#" onClick={this.handleSort}>
                        <i className={sortClass}
                            style={{marginRight: '0.5em'}}
                        ></i>
                        {this.state.sortAsc ? 'Ascending' : 'Descending'}
                    </a>
                </div>

                <ul className={cl}>
                    {this.renderEvents(events)}
                </ul>

            </div>
        </div>);
    },

    renderEvents: function (events) {
        if (events && events.length) {
            return (this.state.sortAsc) ?
                events.map(ScheduleElmt) :
                events.map(ScheduleElmt).reverse();
        }
        return (<div className="alert alert-info">
            No Events found.
        </div>);
    }
});


export default TechnicianSchedule;
